import { CSSProperties } from 'react';

export const textareaStyling: CSSProperties = {
  textDecorationThickness: '1px',
  textDecorationStyle: 'dashed',
  textDecorationLine: 'underline',
  textDecorationColor: '#C0C0C0',
};
